import type { SankeyGraphModel } from '../types/sankey-internal.js';

export function getSankeyIsEmpty(graph: SankeyGraphModel): boolean {
  return graph.nodes.length === 0 || graph.links.length === 0;
}
